import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { useNightMode } from '@src/public/hooks/app';
import styles from './index.css';

const StatusBar = ({ statusBarHeight = 0, lightColor = 'transparent', darkColor = '#222226' }) => {
    const isNightMode = useNightMode();

    return (
        <div
            className={styles.wrap}
            style={{ height: statusBarHeight, backgroundColor: isNightMode ? darkColor : lightColor }}
        />
    );
};

StatusBar.propTypes = {
    statusBarHeight: PropTypes.number,
    lightColor: PropTypes.string,
    darkColor: PropTypes.string,
};

export default errorBoundary(StatusBar);
